import React from 'react';
import {t} from 'ttag';
import {DataGrid} from '@mui/x-data-grid';
import {invoiceItemsColumns as columns, styles} from '@invoice-system';
import {IInvoice} from '../../../store/apis/interfaces/invoice';

interface InvoiceItemsProps {
  data: IInvoice;
}

interface ITableRow {
  id: string | number;
  reference?: string;
  code?: string;
  unitPrice?: string;
  field?: string;
}

export const InvoiceItems = ({data}: InvoiceItemsProps) => {
  const tableRows = [
    {
      id: 'fare',
      reference: t`Fare`,
      code: Array.isArray(data?.details?.Coupons)
        ? data.details.Coupons.map(coupon => coupon.FareCode)
        : 'N/A',
      unitPrice: data?.details?.FareAmount + ' ' + data?.details?.Currency,
    },
      ...Array.isArray(data?.details?.Taxes) ?
        (data?.details?.Taxes || []).reduce((rows: Array<ITableRow>, item) => {
          rows.push({
            id: (item?.Ordinal || '') + 't',
            reference: item?.Caption || '',
            code: item?.Code || 'N/A',
            unitPrice: (item?.Amount || 0) + ' ' + (data?.details?.Currency || 'N/A')
          });
          return rows;
        }, []) : [],
    {
      id: data?.details?.Payment?.length + 1,
      field: 'Total',
      unitPrice: data?.details?.Payment?.reduce((sum, item) => sum + (Number(item?.Amount) || 0), 0)?.toFixed(2) + ' ' + data?.details?.Currency
    }
  ];

  return (
    <DataGrid
      autoHeight
      disableColumnMenu
      hideFooter
      disableRowSelectionOnClick
      rowHeight={35}
      columns={columns}
      sx={styles.table}
      rows={tableRows || []}
    />
  );
};
